<template>
  <qx-card-form title="车型及货物信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <!-- <section slot="plateNumber">
        <ChoosePlateNumber />
      </section>-->

      <section slot="squareAndWeight">
        <el-input class="appendInputBox" v-model="otherFormData.goodsWeight" placeholder="重量">
          <span slot="suffix">
            <span class="unit">吨</span>
            <el-input
              class="inputAppendInput"
              v-model="otherFormData.goodsVolume"
              :clear="true"
              placeholder="容积"
            >
              <span class="unit" slot="suffix">立方</span>
            </el-input>
          </span>
        </el-input>
      </section>

      <section slot="temperatureControl" class="combine-select-box" slot-scope="prop">
        <el-select class="select-box select-box1" v-model="prop.form.tempType" placeholder="请选择">
          <el-option
            v-for="(item, index) in baseForm.tempTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <span class="1234">
          <el-select class="select-box select-box2" v-model="prop.form.tempStart" placeholder="请选择">
            <el-option
              v-for="(item, index) in baseForm.temperatureOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span class="select-box-connect">至</span>
          <el-select class="select-box select-box3" v-model="prop.form.tempEnd" placeholder="请选择">
            <el-option
              v-for="(item, index) in baseForm.temperatureOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
// import ChoosePlateNumber from 'components/choosePlateNumber/choosePlateNumber';
import {
  getCarTypeList,
  getEnumList,
  selectSysStaticDataByCodeType,
} from 'api';
export default {
  components: {
    // ChoosePlateNumber,
  },
  data () {
    return {
      otherFormData: {
        goodsVolume: '',
        goodsWeight: '',
      },
      baseForm: {
        goodsTypeOptions: [],
        vehicleTypeOptions: [],
        tempTypeOptions: [],
        temperatureOptions: [],
        inline: true,
        form: [
          // {
          //   label: '车牌号码',
          //   value: 'plateNumber',
          //   slot: true,
          // },
          {
            label: '车型要求',
            value: 'vehicleType',
            type: 'cascader',
            normal: true,
            default: [],
          },
          {
            label: '体积重量',
            value: 'squareAndWeight',
            slot: true,
          },
          {
            label: '货品类型',
            value: 'goodsType',
            type: 'select',
          },
          {
            label: '货品名称',
            value: 'goodsName',
            type: 'input',
          },
          {
            label: '温控要求',
            value: 'temperatureControl',
            slot: true,
          },
          {
            label: '常温冷冻',
            value: 'tempType',
            type: 'select',
            hide: true,
          },
          {
            label: '常温冷冻',
            value: 'tempStart',
            type: 'select',
            hide: true,
          },
          {
            label: '常温冷冻',
            value: 'tempEnd',
            type: 'select',
            hide: true,
          },

        ],
        rules: {
          vehicleType: [
            { required: true, message: '请选择车型要求', trigger: 'submit' },
          ],
          goodsName: [
            { required: true, message: '输入货品名称', trigger: 'submit' },
          ],
          squareAndWeight: [
            {
              validator: (rule, value, call) => {
                if (this.otherFormData.goodsVolume && this.otherFormData.goodsWeight) {
                  call();
                } else {
                  if (!this.otherFormData.goodsWeight) {
                    call('请输入重量');
                  }
                  if (!this.otherFormData.goodsVolume) {
                    call('请输入体积');
                  }
                }
              },
              trigger: 'submit',
            },
          ],
          goodsVolume: [
            { required: true, message: '请输入体积', trigger: 'submit' },
          ],
          goodsWeight: [
            { required: true, message: '请输入重量', trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    async getOptions () {
      if (!this.baseForm.vehicleTypeOptions.length) {
        const vehicleStatusEnumsList = await getCarTypeList();
        const vehicleTypeOptions = [
          { label: '请选择', value: '-1' },
          ...vehicleStatusEnumsList,
        ];
        this.baseForm.vehicleTypeOptions = vehicleTypeOptions;
      }
      if (!this.baseForm.goodsTypeOptions.length) {
        const enumsList = await getEnumList({
          codeType: 'GOODS_TYPE',
        });
        this.baseForm.goodsTypeOptions = enumsList[0];
      }
      if (!this.baseForm.tempTypeOptions.length) {
        const tempTypeOptions = await selectSysStaticDataByCodeType({
          codeType: 'CITY_LINE_TEMP_TYPE',
          hasAll: true,
        });
        this.baseForm.tempTypeOptions = tempTypeOptions.filter((item) => item.value !== '-1');
      }
      const temperatureOptions = [];
      for (let i = -20; i <= 10; i++) {
        temperatureOptions.push({
          label: i + '度',
          value: i,
        });
      }
      if (!this.baseForm.temperatureOptions.length) {
        this.baseForm.temperatureOptions = temperatureOptions;
      }
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.addressNavigationInfo;
        delete formData.vehicleType;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {

        if (formData.vehicleType && formData.vehicleType.length) {
          formData.vehicleStatus = formData.vehicleType[0];
          formData.vehicleLength = formData.vehicleType[1];
        }

        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async init (data = {}) {

      await this.getOptions();

      if (data.tempType === undefined) {
        // 默认常温
        data.tempType = String(this.baseForm.tempTypeOptions[1].value);
      } else {
        data.tempType = String(data.tempType);
      }
      if (data.tempStart === undefined) {
        // 默认0度
        data.tempStart = 0;
      }
      if (data.tempEnd === undefined) {
        // 默认5度
        data.tempEnd = 5;
      }

      if (data.goodsType === undefined) {
        data.goodsType = this.baseForm.goodsTypeOptions[0].value;
      } else {
        data.goodsType = String(data.goodsType);
      }

      if (data.vehicleStatus && data.vehicleLength) {
        data.vehicleType = [
          String(data.vehicleStatus),
          String(data.vehicleLength),
        ];
      }

      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>

<style scoped lang="scss">
.combine-select-box {
  width: 240px;
  .select-box {
    width: 70px;
  }
  .select-box1 {
    width: 74px;
    ::v-deep .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .select-box2 {
    ::v-deep .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      margin-left: -1px;
      // margin-left: -1px;
      // border-right: 0;
    }
  }
  .select-box3 {
    ::v-deep .el-input__inner {
      // margin-left: -1px;
      // border-left: 0;
    }
  }
  .select-box-connect {
    margin: 0 6px;
  }
}
</style>
